<template>
    <v-tabs v-model="index" background-color="transparent" hide-slider :centered="centered"
        :class="{ 'tabs-group--dense': dense }">
        <v-tab v-for="(tab, i) in tabs" :key="i" :value="tab.value" @click="setTab(tab)"
            :class="`custom-tab${color ? '-' + color : ''}`">
            {{ tab.label }}
            <v-icon v-if="isLocked(tab)" size="13" class="ml-1">mdi-lock-outline</v-icon>
        </v-tab>
    </v-tabs>
</template>

<script>
export default {
    name: "TabsGroup",
    props: {
        tabs: {
            type: Array,
            default: () => []
        },
        value: {
            type: [Number, String],
            default: null,
        },
        color: {
            type: String,
            default: null
        },
        centered: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            model: null,
            index: 0,
        }
    },
    mounted() {
        const vm = this;
        vm.setDefault()
    },
    methods: {
        setDefault() {
            const vm = this
            if (vm.value) {
                vm.model = vm.value
                vm.index = vm.tabs.findIndex(t => vm.model === t.value) || 0
            }
        },
        isLocked(tab) {
            return !!tab?.feature && !this.can(tab.feature)
        },
        setTab(tab) {
            const vm = this;
            if (vm.isLocked(tab)) {
                vm.requirePlan(tab.feature)
                return vm.$nextTick(() => vm.setDefault())
            }
            vm.model = tab?.value || tab
            vm.$emit('change', vm.model)
        }
    },
    watch: {
        value() {
            this.setDefault()
        },
    },

}
</script>

<style scoped>
>>>.v-slide-group__prev {
    display: none !important;
}

>>>.v-tabs-bar {
    background: transparent !important;
    height: 44px;
}

.tabs-group--dense.v-tabs {
    flex: 0 0 auto;
    width: auto;
}

.tabs-group--dense >>> .v-tabs-bar {
    height: 38px;
}

.tabs-group--dense >>> .v-slide-group__content {
    align-items: center;
}

.tabs-group--dense .v-tab.custom-tab,
.tabs-group--dense .v-tab.custom-tab-grey {
    height: 30px !important;
    padding: 0 12px !important;
    font-size: 11px;
}

.v-tab.custom-tab,
.v-tab.custom-tab-grey {
    height: 36px !important;
    min-width: auto !important;
    padding: 0 14px !important;
    margin-right: 4px;
    border-radius: 7px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: .05em;
    text-transform: uppercase;
    color: var(--v-txtMuted-base) !important;
    transition: background .15s, color .15s;
}

.v-tab.custom-tab::before,
.v-tab.custom-tab-grey::before {
    display: none !important;
}

.v-tab.custom-tab:hover,
.v-tab.custom-tab-grey:hover {
    background: var(--v-surface2-base);
    color: var(--v-txtSecondary-base) !important;
}

.theme--dark .v-tab--active.custom-tab,
.theme--dark .v-tab--active.custom-tab-grey {
    background: rgba(204, 255, 51, .12);
    color: var(--v-primary-base) !important;
}

.theme--light .v-tab--active.custom-tab,
.theme--light .v-tab--active.custom-tab-grey {
    background: rgba(51, 153, 153, .1);
    color: var(--v-accent-base) !important;
}
</style>